module.exports = __webpack_public_path__ + "img/fail_icon.f28890a2.svg";